import { useState } from "react";
import Body from "./Body";
const FeeSetup = () => {
  const [currentComponent, setCurrentComponent] = useState("1");


  const _this = { currentComponent, setCurrentComponent };
  return <Body {..._this} />;
};

export default FeeSetup;
